import Vue from 'vue'
import VueAuth from '@websanova/vue-auth'
import router from '../router'
import config from './config'

Vue.router = router
// 初始化auth模块
Vue.use(VueAuth, config)

// 是否已经登录
Vue.prototype.$auth.hasLogined = Vue.prototype.$auth.watch.authenticated
